<template>
    <section class="megamenu_wrapper">
        <div class="megamenu_inner">
            <div class="megamenu-container row flex-wrap">
                <div class="megamenu-items col-lg-4 p-0 pl-2">
                    <div class="dd-icon-features-container">           
                        <div class="mega-menuitem-header d-flex justify-content-between">
                          <div class="icon-wrapper col-3 pr-2 text-center p-0">

                              <!-- <img
                                  loading="eager"
                                  :src="'/images/icons/megamenu-icon1.svg'"
                                  alt="Earn Money"
                                  class="drop-down_feature-icon"
                              /> -->
                          </div>
                            <div class="dd-features-div col-9 p-0">
                                <!-- <div class="dd-features-heading">
                                    Attract Customers
                                </div>
                                <p class="ufl-help-text nav-bar f-8">
                                    Get more customers with marketing and retention
                                </p> -->
                                <div class="header_mega-menu-links">
                                <li class="menu-item_link py-2">
                                <a
                                    href="/features/marketing"
                                    class="dropdown-link w-dropdown-link  text-dark  f-17"
                                    tabindex="0"
                                    >Marketing</a
                                >
                            </li>
                           <li class="menu-item_link py-2"> <a
                                href="/features/online-appointments"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Client Appointment Scheduling</a
                            ></li>
                            <li class="menu-item_link py-2"><a
                                href="/features/store-credits"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Store Credits</a>
                        </li>
                         <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Device Management</a
                            ></li>
                             <li class="menu-item_link py-2"><a
                                href="https://ifixyour.com/"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Ask an Expert</a
                            ></li>
                            <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Feedback Collection</a
                            ></li>
                        <!-- <li class="menu-item_link py-2"><a
                                href="/features/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Loyalty Program</a
                            >
                        </li> -->
                        <!-- <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Gift Cards</a
                            ></li> -->
                            </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="megamenu-items col-lg-4 p-0 pl-2">
                    <div class="dd-icon-features-container">           
                        <div class="mega-menuitem-header d-flex justify-content-between">
                          <div class="icon-wrapper col-3 pr-2 text-center p-0">

                              <!-- <img
                                  loading="eager"
                                  alt="Earn Money"
                                  :src="'/images/icons/megamenu-icon2.svg'"
                                  class="drop-down_feature-icon"
                              /> -->
                          </div>
                            <div class="dd-features-div col-9 p-0">
                                <!-- <div class="dd-features-heading">
                                Sell More
                            </div>
                            <p class="ufl-help-text nav-bar f-8">
                                Tools to help you sell more repairs and
                                accessories
                            </p> -->
                                <div class="header_mega-menu-links">
                                    <li class="menu-item_link py-2"><a
                                href="/features/point-of-sale"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Repair Shop POS</a
                            ></li>
                             <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Enterprise & B2B Support</a
                            ></li>
                            <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Task Management</a
                            ></li>
                             <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Support Ticket Management</a
                            ></li>
                             <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Mail-in Client Support</a
                            ></li>
                            <li class="menu-item_link py-2"><a
                                href="/features/payments"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Payments</a
                            ></li><li class="menu-item_link py-2"><a
                                href="/features/self-check-in"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Self Check-In</a
                            ></li><li class="menu-item_link py-2"><a
                                href="/features/customer-facing"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Customer Facing Display</a
                            ></li>
                            <!-- <li class="menu-item_link py-2"><a
                                href="#"
                                class="dropdown-link phone-system w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Phone System
                                <span class="comingsoon">Coming Soon</span></a
                            ></li> -->
                            </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="megamenu-items col-lg-4 p-0 pl-2">
                    <div class="dd-icon-features-container">           
                        <div class="mega-menuitem-header d-flex justify-content-between">
                          <div class="icon-wrapper col-3 pr-2 text-center p-0">

                              <!-- <img
                                  loading="eager"
                                  :src="'/images/icons/megamenu-icon3.svg'"
                                  alt="Earn Money"
                                  class="drop-down_feature-icon"
                              /> -->
                          </div>
                            <div class="dd-features-div col-9 p-0">
                                <!-- <div class="dd-features-heading">
                                Increase Efficiency
                            </div>
                            <p class="ufl-help-text nav-bar f-8">
                                Reduce costs and optimize your store operations
                            </p> -->
                                <div class="header_mega-menu-links">
                                    <li class="menu-item_link py-2"><a
                                href="/features/repair-ticket"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Repair Ticket Management</a
                            ></li><li class="menu-item_link py-2"><a
                                href="/features/employee-management"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Employee Management</a
                            ></li><li class="menu-item_link py-2"><a
                                href="/features/inventory"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Inventory</a
                            ></li><li class="menu-item_link py-2"><a
                                href="/features/billing-invoice"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Billing and Invoices</a
                            ></li><li class="menu-item_link py-2"><a
                                href="/features/reporting"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >Reporting</a
                            ></li><li class="menu-item_link py-2"><a
                                href="coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >iOS/Android App for Clients</a
                            ></li><li class="menu-item_link py-2"><a
                                href="coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17"
                                tabindex="0"
                                >iOS/Android App for Management</a
                            ></li>
                             <li class="menu-item_link py-2"><a
                                href="/coming_soon"
                                class="dropdown-link w-dropdown-link  text-dark  f-17" data-id="point-of-sale"
                                tabindex="0"
                                >Employee & Technician Schedule Management</a
                            ></li>
                            </div>
                            </div>
                        </div> 
                    </div>
                </div>
              
            </div>
        </div>
    </section>
</template>
<script>
export default {
    mounted(){
         

            // $('.menu-item_link a').click(function(e) {
            //     $(this).addClass('fw-bold');
            //      localStorage.setItem('activeMenuIndex', 1);
            //  });
            //  if(activeMenuIndex !== null && activeMenuIndex !=0){
            //     $('.nav-item a').removeClass('fw-bold');
            //   }
    
}
}
</script>